import { render, staticRenderFns } from "./ItemsListBasic.vue?vue&type=template&id=15838d19&"
import script from "./ItemsListBasic.vue?vue&type=script&lang=js&"
export * from "./ItemsListBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports